<template>
    <div>
        <sav-template
        title=""
        :back-button="false"
        >
            <sav-spinner v-if="loading" :size="10" />
            <sav-timeline-form v-if="startStep" :start="startStep" />
        </sav-template>
    </div>
</template>

<script>
import SavTimelineForm from '../../../../components/SavTimelineForm.vue'
import apiService from '@/services/api.service'

export default {
    components: { SavTimelineForm },
    data() {
        return {
            startStep: null,
            loading: false
        }
    },
    methods: {
        async init() {
            let stepName = this.$companyTool.processConf().start

            if (stepName == 'brand') {
                this.loading = true
                const brandResponse = await apiService.post('getbrand', {
                    marque: null
                })
                if (brandResponse.data.posts.post && brandResponse.data.posts.post.length == 1) {
                    this.$formTool.addFormData('brand', {...brandResponse.data.posts.post[0], label: brandResponse.data.posts.post[0].marque})
                    stepName = this.$formTool.blockData(stepName).next
                }

                if (stepName == 'category') {
                    let responseCateg = await apiService.post('getgroup', {
                        marque: brandResponse.data.posts.post[0].marque
                    })
                    if (responseCateg.data.posts.post && responseCateg.data.posts.post.length == 1) {
                        this.$formTool.addFormData('category', responseCateg.data.posts.post[0])
                        stepName = this.$formTool.blockData(stepName).next.device
                    }
                }
                this.loading = false
            }
            this.startStep = stepName
        }
    },
    mounted() {
        if (this.$companyTool.confFile().login_oblig == 1 && !localStorage.getItem('client_id')) {
            this.$router.push({name: 'welcome'})
            return
        }
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/form/Home.vue